import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { img } from "@/data/images";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const ImageSlotsContext = createContext({ slots: {}, ready: false });

export function ImageSlotsProvider({ children }) {
  const [slots, setSlots] = useState({});
  const [ready, setReady] = useState(false);
  useEffect(() => {
    axios.get(`${API}/image-slots/public`).then((r) => setSlots(r.data || {})).catch(() => {}).finally(() => setReady(true));
  }, []);
  return <ImageSlotsContext.Provider value={{ slots, ready }}>{children}</ImageSlotsContext.Provider>;
}

// Returns resolved slot data or null. { src, alt, conceptual, caption }
export function useSlot(key) {
  const { slots } = useContext(ImageSlotsContext);
  const s = slots[key];
  if (!s || !s.url) return null;
  return { src: img(s.url), alt: s.alt || "", conceptual: !!s.conceptual, caption: s.caption || "" };
}

export const useImageSlots = () => useContext(ImageSlotsContext);
